import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_PROMISE } from "./stripe";

type StripeElementsProviderProps = {
  children: React.ReactNode;
};

function StripeElementsProvider(props: StripeElementsProviderProps) {
  const { children } = props;

  const elementsOptions = {
    fonts: [
      {
        cssSrc:
          "https://fonts.googleapis.com/css?family=Poppins:300,300i,400,500,600",
      },
    ],
  };

  return (
    <Elements options={elementsOptions} stripe={STRIPE_PROMISE}>
      {children}
    </Elements>
  );
}

export default StripeElementsProvider;
